import React, { Component, ReactNode } from 'react';
import { HashRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import {AppRoot, List, Section, Cell} from '@telegram-apps/telegram-ui';

import FormSection from './FormSection/FormSection';
import { HeaderSection } from "./HeaderSection/HeaderSection";
import CatalogPage from './CatalogPage/CatalogPage';
import ItemPage from './ItemPage/ItemPage';
import CartPage from './CartPage/CartPage';
import {BackButton} from "./components/BackButton";
import { CartButton } from "./components/CartButton/CartButton";
import { CartProvider } from "./context/CartContext";

// Error page component that can use hooks
function ErrorPage({ error }: { error: Error | null }) {
  const navigate = useNavigate();
  return (
    <>
      <BackButton onClick={() => navigate('/')} />
      <Section header="Ошибка">
        <Cell>{error?.message || 'Unknown error'}</Cell>
        <Cell subtitle="Stack">{error?.stack?.slice(0, 200)}</Cell>
      </Section>
    </>
  );
}

// Error Boundary to catch React errors
interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage error={this.state.error} />;
    }
    return this.props.children;
  }
}

function HomePage() {
  return (
    <List>
      <HeaderSection />
      <FormSection />
    </List>
  );
}

function App() {

  return (
    <HashRouter>
      <ErrorBoundary>
        <CartProvider>
          <AppRoot>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/catalog" element={<CatalogPage />} />
              <Route path="/item/:itemId" element={<ItemPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <CartButton />
          </AppRoot>
        </CartProvider>
      </ErrorBoundary>
    </HashRouter>
  );
}

export default App;
